module.exports = __webpack_public_path__ + "img/settings-nav.8049aba6.svg";